import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ICreateRuleInGroupRequest, IRuleSettings, IUpdateRuleRequest, IValidateRuleRequest, IRuleFromXMLRequest } from '../models/rule-editor.model';
import { environment } from "@environments/environment";

@Injectable({
  providedIn: 'root'
})

export class RuleEditorService {
 url: string =  environment.apiUrl;

  constructor(private http: HttpClient) { }

  async getRuleEditorSettings(editorId: string, ruleGroupId: number, newRule: boolean): Promise<IRuleSettings>{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return new Promise((resolve, reject) => {
      this.http.get<IRuleSettings>(`${this.url}/Editor/Settings/${editorId}`,
        { 
          headers,
          params: new HttpParams().set('editorId', editorId)
          .set('ruleGroupId', ruleGroupId)  
          .set('newRule', newRule)  
        }).subscribe({
        next: (result) => resolve(result),
        error: (error) => reject(error)
      });
    });
  };

  async getRuleData(ruleId: number): Promise<string>{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return new Promise((resolve, reject) => {
      this.http.get<any>(`${this.url}/rules/getRuleData/${ruleId}`, { headers }).subscribe({
        next: (result) => resolve(result.ruleData),
        error: (error) => reject(error)
      });
    });
  };

  async getRuleFromXML(editorId: string, xml: string): Promise<string>{
    const request: IRuleFromXMLRequest ={
      editorId: editorId,
      sourceXml: xml
    }
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return new Promise((resolve, reject) => {
      this.http.post<any>(`${this.url}/Editor/getRuleFromXML`, request, { headers }).subscribe({
        next: (result) => resolve(result.ruleData),
        error: (error) => reject(error)
      });
    });
  };
 
  async validateRule(request: IValidateRuleRequest): Promise<any>{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return new Promise((resolve, reject) => {
      this.http.post(`${this.url}/rules/validate`, request,  { headers }).subscribe({
        next: (result) => resolve(result),
        error: (error) => reject(error)
      });
    });
  }

  async deleteRule(ruleId: number): Promise<any>{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return new Promise((resolve, reject) => {
      this.http.delete(`${this.url}/rules/${ruleId}`, { headers}).subscribe({
        next: (result) => resolve(result),
        error: (error) => reject(error)
      });
    });
  }

  async updateRule(request: IUpdateRuleRequest): Promise<any>{
    return new Promise((resolve, reject) => {
      this.http.patch(`${this.url}/rules/${request.ruleID}`, request).subscribe({
        next: (result) => resolve(result),
        error: (error) => reject(error) 
      });
    });
  }

  async createRuleInGroup(request: ICreateRuleInGroupRequest): Promise<any>{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return new Promise((resolve, reject) => {
      this.http.post(`${this.url}/rules/createRuleInGroup`, request, {headers}).subscribe({
        next: (result) => resolve(result),
        error: (error) => reject(error) 
      });
    });
  }
}
